// api.js
import axios from 'axios';
import axiosRetry from 'axios-retry';
import url from './serverUrl';

export const api = axios.create({
  baseURL: url,
  headers: {
    'x-secret-key':
      '3af7d905b99ace11a03b3250f037612d8429e3084985242f227766418946eac4'
  }
});

axiosRetry(api, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000; // 1s, 2s, 3s
  },
  retryCondition: (error) => {
    return (
      axiosRetry.isNetworkError(error) || axiosRetry.isRetryableError(error)
    );
  }
});
